import { quSave } from '@/service/question'
import util from '@/tools/commonUtil'
import iconSrc from '@/assets/images/edit/config/m-lef-sort@2x.png'
export default {
  id: '',
  groupId: '',
  belongId: '',
  isRequired: '1',
  orderById: 100,
  elementType: 'SortBox',
  elementDesc: '排序题',
  type: 'sortbox',
  // 是否可配置
  config: true,
  title: '排序题',
  placeholder: '排序题',
  itemName: 'optionList',
  imgUrl: '',
  imgName: '',
  optionList: [{
    id: '',
    optionName: '',
    orderById: 1,
    type: 'normal',
    imgUrl: '',
    imgName: '',
    value: 0
  }, {
    id: '',
    optionName: '',
    orderById: 2,
    type: 'normal',
    imgUrl: '',
    imgName: '',
    value: 0
  }],
  vertical: true,
  value: [],
  tipsAllSort: '请对所有选项进行排序',
  tipsMaxSort: '最多选出前${n}位',
  ruleError: '该字段不能为空',
  saveUrl: '/design/qu-orderqu/ajaxSave.do',
  iconStyle: {
    width: '11px',
    height: '11px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
      optionList: util.genList(this.optionList),
      maxSortNum: this.maxSortNum
    }, this)
  },
  saveCb (data) {
    this.optionList = util.genRetList.call(this, data.optionList, 'option', {value: 0})
    this.sortType = data.sortType
    this.maxSortNum = data.maxSortNum
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      orderyNum: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/SortBox/config.js